<section class="p-0">
  @if ((notifications$ | async); as notifications) {
    <ul [class.is-popup]="isPopup" class="notification-list">
      @for (notification of notifications; track notification) {
        <li>
          <app-notification-message [notification]="notification"></app-notification-message>
        </li>
      }
      @if (!notifications.length) {
        <li
          class="notification fs-default mb-10 p-25 w-100 border-radius bg-white shadow text-center">
          <span class="fw-700 mb-20">No notifications</span>
        </li>
      }
      @if (isPopup && user.isClient()) {
        <li
          class="all-notifications redirection-link fs-default c-primary bg-white text-center p-15 pointer shadow fw-700"
          [routerLink]="user.isClient() ? '/client/notifications' : '/firm/notifications'">
          See all notifications
        </li>
      }
    </ul>
  }
</section>
